import { axiosInstance } from "./axios";

export const IntegrationAccessAPI = {

    /**
     * Generate a new API key for a reseller.
     * @param {Object} payload - Body containing the reseller userId.
     * @param {string} [token=""] - Authorization token.
     * @returns {Promise} Axios promise — returns the generated key in data.data.apiKey.
     */
    generateApiKey: (payload, token = "") => {
        return axiosInstance(token).post("/integration-access/api-keys", payload);
    },

    /**
     * List all active API keys for a reseller.
     * @param {string} userId - The MongoDB ID of the reseller.
     * @param {string} [token=""] - Authorization token.
     * @returns {Promise} Axios promise — returns array in data.data.
     */
    getApiKeys: (userId, token = "") => {
        return axiosInstance(token).get(`/integration-access/api-keys/${userId}`);
    },

    /**
     * Revoke a specific API key for a reseller.
     * @param {string} userId - The MongoDB ID of the reseller.
     * @param {string} keyId - The ID of the API key to revoke.
     * @param {string} [token=""] - Authorization token.
     * @returns {Promise} Axios promise.
     */
    revokeApiKey: (userId, keyId, token = "") => {
        return axiosInstance(token).delete(`/integration-access/api-keys/${userId}`, { data: { keyId } });
    }
};
